import { Sine, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class PatchStitch extends PIXI.Sprite {
    private _tween: TweenLite | undefined;

    constructor() {
        super();
        const assetName: string = "stitch-0" + HLF.Random.intBetween(0, 3);
        this.texture = PIXI.loader.resources[Constants.SPRITESHEET_QUILT_PREFIX + "00"].textures![assetName];
        this.rotation = HLF.Random.floatBetween(-0.6, 0.6);
        this.anchor.set(0.5);
        this.scale.set(0.5);
        this.hide(true);
    }

    public show(pImmediately: boolean = false): void {
        this.killTween();
        this.visible = true;
        this._tween = TweenLite.to(this, pImmediately ? 0 : 0.5, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
    }

    public hide(pImmediately: boolean = false): void {
        this.killTween();
        this._tween = TweenLite.to(this, pImmediately ? 0 : 0.25, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => { this.visible = false; },
        });
    }

    private killTween(): void {
        if (this._tween !== undefined) {
            this._tween.kill();
        }
    }
}
